//====================================================
//  Function: Google Map
//====================================================
function fn_components_google_map(){
    $('.object-map .map-block').each(function() {
        var inst = $(this);
        var id = inst.attr('id');
        fn_components_map_init(id);
    });
}

function fn_components_map_init(mapId){
	var map
    var mapOptions = {
        zoom: 8,
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false,
        center: new google.maps.LatLng(50.0809813, 14.396636),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [{featureType:"administrative",elementType:"labels.text.fill",stylers:[{color:"#444444"}]},{featureType:"administrative.neighborhood",elementType:"geometry.fill",stylers:[{color:"#d71818"}]},{featureType:"administrative.neighborhood",elementType:"labels.text.fill",stylers:[{color:"#a1b953"}]},{featureType:"administrative.land_parcel",elementType:"geometry.fill",stylers:[{color:"#ce1111"}]},{featureType:"landscape",elementType:"all",stylers:[{color:"#f2f2f2"}]},{featureType:"landscape",elementType:"geometry.fill",stylers:[{color:"#fbf8f5"},{saturation:"0"},{gamma:"0.75"},{weight:"1"}]},{featureType:"landscape.man_made",elementType:"labels.text",stylers:[{color:"#d91818"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{saturation:-100},{lightness:45}]},{featureType:"road.highway",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"road.arterial",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{color:"#ffffff"},{visibility:"on"}]}]
    };
    map = new google.maps.Map(document.getElementById(mapId), mapOptions);

    var gmarkers = [];
    var bounds = new google.maps.LatLngBounds();
    var objects = [];
    

    function markerSet(image, width, height){
        return new google.maps.MarkerImage(
            image,
            new google.maps.Size(width, height),
            // The origin for my image is 0,0.
            new google.maps.Point(0, 0),
            // The center of the image is 50,50 (my image is a circle with 100,100)
            new google.maps.Point(width / 2, height)
        );
    }

    var imageApple = markerSet('images/marker-apple.png', 45, 56);
    var imageAppleActive = markerSet('images/marker-apple-active.png', 63, 79);
    var imagePear = markerSet('images/marker-pear.png', 45, 56);
    var imagePearActive = markerSet('images/marker-pear-active.png', 63, 79);
    var imageCherry = markerSet('images/marker-cherry.png', 45, 56);
    var imageCherryActive = markerSet('images/marker-cherry-active.png', 63, 79);

    if (mapId == 'map-detail'){
        var markers = [
            {
                "id": '1',
                "icon": imageAppleActive,
                // "icon_active": imageApple,
                "longitude": 48.091922,
                "latitude": 18.423461,
                "url": "detail.html"
            }, {
                "id": '2',
                "icon": imagePear,
                // "icon_active": imagePear,
                "longitude": 50.090564,
                "latitude": 14.413077,
                "url": "detail.html"
            }, {
                "id": '3',
                "icon": imageCherry,
                // "icon_active": imageCherry,
                "longitude": 50.090802,
                "latitude": 14.463077,
                "url": "detail.html"
            }, {
                "id": '4',
                "icon": imageApple,
                // "icon_active": imageApple,
                "longitude": 50.110702,
                "latitude": 14.403077,
                "url": "detail.html"
            }, {
                "id": '5',
                "icon": imageCherry,
                // "icon_active": imageCherry,
                "longitude": 48.212535,
                "latitude": 19.335488,
                "url": "detail.html"
            }, {
                "id": '6',
                "icon": imagePear,
                // "icon_active": imagePear,
                "longitude": 51.090564,
                "latitude": 16.413077,
                "url": "detail.html"
            }
        ]
    } else {
        var markers = [
            {
                "id": '1',
                "icon": imageApple,
                // "icon_active": imageApple,
                "longitude": 50.091922,
                "latitude": 14.423461,
                "url": "detail.html"
            }, {
                "id": '2',
                "icon": imagePear,
                // "icon_active": imagePear,
                "longitude": 50.090564,
                "latitude": 14.413077,
                "url": "detail.html"
            }, {
                "id": '3',
                "icon": imageCherry,
                // "icon_active": imageCherry,
                "longitude": 50.090802,
                "latitude": 14.463077,
                "url": "detail.html"
            }, {
                "id": '4',
                "icon": imageApple,
                // "icon_active": imageApple,
                "longitude": 50.110702,
                "latitude": 14.403077,
                "url": "detail.html"
            }, {
                "id": '5',
                "icon": imageCherry,
                // "icon_active": imageCherry,
                "longitude": 48.212535,
                "latitude": 19.335488,
                "url": "detail.html"
            }, {
                "id": '6',
                "icon": imagePear,
                // "icon_active": imagePear,
                "longitude": 51.090564,
                "latitude": 16.413077,
                "url": "detail.html"
            }
        ]
    }


    for (var i = 0; i < markers.length; ++i) {
        var latLng = new google.maps.LatLng(markers[i].longitude, markers[i].latitude)

        var marker = new google.maps.Marker({
            position: latLng,
            draggable: false,
            icon: markers[i].icon,
            // active: markers[i].icon_active,
            id: markers[i].id,
            name: markers[i],
            url: markers[i].url
        });

        google.maps.event.addListener(marker, 'click', function(e){
        	window.location.href = this.url;
        });

        bounds.extend(marker.position);
        marker.setMap(map);
        gmarkers.push(marker);
    }


    // Clustering from Tempish
    if (markers.length > 1) {

        var clusterStyles = [
            {
                textColor: '#ed1c24',
                url: 'images/cluster-marker.png',
                width: 50,
                height: 50,
                cssClass: "cluster-style"
            }
        ];

        var mcOptions = {
            zoom: 13,
            gridSize: 50,
            maxZoom: 15,
            styles: clusterStyles
        };

        var mc = new MarkerClusterer(map, gmarkers, mcOptions);

        ClusterIcon.prototype.onAdd = function () {
            this.div_ = document.createElement('DIV');
            if (this.visible_) {
                var pos = this.getPosFromLatLng_(this.center_);
                this.div_.style.cssText = this.createCss(pos);

                var innerHtml;

                if (this.cluster_.markers_.length > 0) {
                    innerHtml = "<div class='clusterer-text'>" + this.sums_.text + "</div>";
                }

                this.div_.innerHTML = innerHtml;
            }

            var panes = this.getPanes();
            panes.overlayMouseTarget.appendChild(this.div_);

            var that = this;
            google.maps.event.addDomListener(this.div_, 'click', function () {
                that.triggerClusterClick();
            });
        };
    }

    map.fitBounds(bounds);

    //  pokud je pocet nalezenych vysledku roven 1 => nastav zoom
    var listener = google.maps.event.addListener(map, "idle", function () {
        if (markers.count == 1) {
            map.setZoom(15);
        }
        google.maps.event.removeListener(listener);
    });

}

